import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "content-dashboard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "reportes mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "reportes__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Marketing Call")
], -1)
const _hoisted_6 = { class: "reports__section1 tw-justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mt-5" }, " STATE ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select state", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "reports__button d-flex justify-content-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "reports__data mt-3 pb-3 position-relative" }
const _hoisted_13 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Loading data...", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "w-100 bg-white p-3 rounded-4"
}
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Note: By pressing \"Save\", an email will be sent with the selected code.")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "text-muted mb-0" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "REAL STATE TEAM"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "LAST NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMPANY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "email-column"
    }, "EMAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COUNTY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ZIPCODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SUBSYSTEM CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SENT DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_25 = { class: "email-column" }
const _hoisted_26 = ["onUpdate:modelValue", "onFocus"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Subsystem Codes", -1)
const _hoisted_28 = ["value"]
const _hoisted_29 = ["onClick", "disabled"]
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_31 = {
  key: 2,
  class: "text-center p-4"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "No subsystem requests found for the selected state.", -1)
const _hoisted_33 = [
  _hoisted_32
]

import { ref, onMounted, computed, reactive } from 'vue';
import TopBar from '@/components/admin/TopBar.vue';
import axios from 'axios';
import { environment } from "@/environment";
import { useToast } from "@/composables/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'marketingCall',
  setup(__props) {

const toast = useToast();
const loading = ref(false);
const state = ref(null);
const listStates = ref([]);
const subsystemData = ref([]);
const loadingSubsystemCodes = ref({});
const url = environment.URL_API;

const formatDate = (dateString: string) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  } catch (error) {
    return '-';
  }
};

const getSubsystemRequests = async () => {
  if (!state.value || state.value === null) {
    toast.error("Please select a state", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  loading.value = true;
  subsystemData.value = [];

  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/subsystem-code`,
      params: {
        state: state.value.state
      }
    });

    if (response.data.success) {
      subsystemData.value = (response.data.request || []).map(item => ({
        ...item,
        selectedCode: null,
        codesLoaded: false 
      }));
    } else {
      toast.error("Error loading data: " + (response.data.message || 'Unknown error'), {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    toast.error("Error loading subsystem requests", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loading.value = false;
  }
};

const loadCodesForRow = async (rowData: any, index: number) => {
  if (rowData.codesLoaded || loadingSubsystemCodes.value[index]) {
    return;
  }

  if (!rowData.county || !rowData.real_estate_team) {
    toast.error("Missing county or real estate team information", {
      position: "top-end",
      timer: 2000,
      showCloseButton: true,
    });
    return;
  }

  loadingSubsystemCodes.value[index] = true;

  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-codes-filtered`,
      params: {
        state: state.value.state,
        county: rowData.county,
        real_estate_team: rowData.real_estate_team
      }
    });

    if (response.data.success && response.data.codes) {

      rowData.availableCodes = response.data.codes;

    } else {

      toast.error(`No codes found for ${rowData.county}`, {
        position: "top-end",
        timer: 2000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    console.error(`Error loading codes for row ${index}:`, error);

    toast.error("Error loading subsystem codes", {
      position: "top-end",
      timer: 2000,
      showCloseButton: true,
    });
  } finally {
    loadingSubsystemCodes.value[index] = false;
  }
};

const getStates = async () => {
  loading.value = true;
  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-states`
    });

    if (response.data.success) {
      listStates.value = response.data.states;
    } else {
      toast.error("Error loading states", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading states", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

const updateRequest = async (data: any, index: number) => {
  if (!data.selectedCode) {
    toast.error("Please select a subsystem code", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  if (!data.ID) {
    toast.error("Invalid record ID", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  loadingSubsystemCodes.value[index] = true;

  try {
    console.log('Updating code for:', data.name, 'to:', data.selectedCode);
    console.log('ID:', data.ID);

    const response = await axios({
      method: "PUT",
      url: `${url}realtor-format/update-request`,
      data: {
        ID: data.ID,
        code: data.selectedCode
      }
    });

    if (response.data.success) {
      data.code = data.selectedCode;

      toast.success(`Subsystem code updated successfully`, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      toast.error(response.data.message || 'Error updating record', {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    console.error('Error updating request:', error);
    toast.error("Error updating subsystem code", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } finally {
    loadingSubsystemCodes.value[index] = false;
  }
};

onMounted(() => {
  getStates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TopBar),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _withDirectives((_openBlock(), _createElementBlock("select", {
                class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                style: {"width":"150px"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state).value = $event)),
                onChange: getSubsystemRequests,
                key: 'state-select'
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: state.state,
                    value: state
                  }, _toDisplayString(state.state), 9, _hoisted_9))
                }), 128))
              ], 32)), [
                [_vModelSelect, state.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (getSubsystemRequests())),
              disabled: loading.value || !state.value
            }, " GENERATE", 8, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
              : (subsystemData.value && subsystemData.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _hoisted_20,
                      _createElementVNode("h6", null, "Subsystem Requests for " + _toDisplayString(state.value?.state), 1),
                      _createElementVNode("p", _hoisted_21, "Total requests: " + _toDisplayString(subsystemData.value.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("table", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subsystemData.value, (data, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: data.ID || index
                            }, [
                              _createElementVNode("td", null, _toDisplayString(data.real_estate_team || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(data.name || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(data.last_name || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(data.company_name || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(data.phone_number || '-'), 1),
                              _createElementVNode("td", _hoisted_25, _toDisplayString(data.email || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(data.county || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(data.zip_code || '-'), 1),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select form-select-sm",
                                  "onUpdate:modelValue": ($event: any) => ((data.selectedCode) = $event),
                                  onFocus: ($event: any) => (loadCodesForRow(data, index))
                                }, [
                                  _hoisted_27,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.availableCodes, (code) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: code,
                                      value: code
                                    }, _toDisplayString(code), 9, _hoisted_28))
                                  }), 128))
                                ], 40, _hoisted_26), [
                                  [_vModelSelect, data.selectedCode]
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(data.createDate), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  class: "btn btn-success btn-sm",
                                  onClick: ($event: any) => (updateRequest(data, index)),
                                  disabled: loadingSubsystemCodes.value[index] || !data.selectedCode
                                }, [
                                  (loadingSubsystemCodes.value[index])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(loadingSubsystemCodes.value[index] ? 'SAVING...' : 'SAVE'), 1)
                                ], 8, _hoisted_29)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : (!loading.value && state.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                  : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})